import React from 'react';
import debounce from 'lodash.debounce';
import Icon from '../Icons/Icon';

import $ from 'jquery';
import si from 'si';

import ProductBrowseActions from './ProductBrowseActions';
import ProductBrowseStore from './ProductBrowseStore';
import CartActions from '../Cart/CartActions';
import CartStore from '../Cart/CartStore';

import CategoryArea from './CategoryArea'; //need to move to ProductGrid.js, not use here
import CategoryDropdown from './CategoryDropdown';
const ajax = require('ajax');
/*
window.onload = function() {
    if (window.jQuery) {    
       //console.log('jQuery is loaded');
    } else {
       //console.log('jQuery IS NOT loaded!');
    }
}

var bootstrap_enabled = (typeof $().modal == 'function');
if(bootstrap_enabled === false) {
   //console.log('Bootstrap IS NOT loaded!');
} else {
   //console.log('Bootstrap is loaded');
}

$('.user-welcome-msg').html('jQuery Loaded');
*/



import BreadCrumbs from './BreadCrumbs';
import ProductGrid from './ProductGrid';



const locationOrigin = window.jenkon.consultantRoot + "Products";

const cdnbaseurl = $('body').attr('data-cdnbaseurl');
//alert(cdnbaseurl);
const cdnimageurl = $('body').attr('data-cdnimageurl');
//alert(cdnimageurl);

export default class ProductBrowse extends React.Component {
	constructor(props) {
		super(props);

        
        this.state = ProductBrowseStore.getState();
        
        this.getCurrentCategoryDescription = this.getCurrentCategoryDescription.bind(this);

        this.getCurrentCategoryLongDescription = this.getCurrentCategoryLongDescription.bind(this);

        this.setBannerImage = this.setBannerImage.bind(this);

        this.fileExists = this.fileExists.bind(this);
		this.getBannerImageUrl = this.getBannerImageUrl.bind(this);
		this.addDefaultSrc = this.addDefaultSrc.bind(this);
	}

	componentWillMount(){
		this.setState({
			gridClass: 'product-grid',
			resources: this.props.resources,
		});
		this.handlescroll = debounce(this.handlescroll, 100);
       //console.log(this.cart);

       

       
	}

    componentDidMount() {

		window.addEventListener('scroll', this.handlescroll.bind(this));
		ProductBrowseStore.listen(this.onChange.bind(this));
	
		ProductBrowseActions.initialSetup(() => {
		    this.cart = CartStore.getState();
		    let cartCurrency = this.cart.primaryCurrency;
		    if (typeof  cartCurrency === 'undefined') {
		        cartCurrency= si.getCartCurency();
		        

		    }
				let sendData = {
				categoryID: this.state.currentCategoryID,
				currency: cartCurrency,
				page: 1,
				searchTerm: this.state.SearchTerms,
				resultCount: this.state.resultCount
            };

  
		this.fillInitialPages(sendData);
            ProductBrowseActions.getCategories();
            
        });

}

componentWillUnmount() {
	window.removeEventListener('scroll', this.handlescroll.bind(this));
	ProductBrowseStore.unlisten(this.onChange.bind(this));
    }




onChange(state) {
	this.setState(state);
}

handlescroll(){
	let docHeight = $(document).height(),
		h = window.innerHeight,
		wTop = $(window).scrollTop(),
		offset = 150;
	if (this.state.canSearch && wTop > (docHeight - h - offset) && !this.state.isLoading) {
		this.setState({
			isLoading: true,
			currentPage: this.state.currentPage + 1
        }, () => {
			let sendData = {
				categoryID: this.state.currentCategoryID,
				currency: this.cart.primaryCurrency,
				page: this.state.currentPage,
				searchTerm: this.state.SearchTerms,
				resultCount: this.state.resultCount
			};
		ProductBrowseActions.getMoreProducts(sendData);
		this.setURL();
	})
		}
}

fillInitialPages(sendData){
    ProductBrowseActions.getNewProducts(sendData);
   
}

    getProductsForCategory(data) {
       //console.log('data:');
      //console.log(data);

	this.setState({
        currentCategoryID: data.code,
        categoryInfo: {
            selectedParentCategory: 0,
            selectedParentCategoryName: '',
            selectedCategoryName: data.description,
            selectedCategoryID: 0
        }
	}, () => {
		let sendData = {
			categoryID: this.state.currentCategoryID,
			currency: this.cart.primaryCurrency,
			page: this.state.currentPage,
			searchTerm: this.state.SearchTerms,
			resultCount: this.state.resultCount
		};
	ProductBrowseActions.getNewProducts(sendData);
	this.setURL();
})
};


//Replace the current History Record with the new values
setURL(){
	window.location.replace(`${locationOrigin}#${encodeURIComponent(this.state.SearchTerms.join(','))}|${this.state.currentCategoryID}|${this.state.currentPage}`);
this.setState({
	isProductSearch: this.state.SearchTerms.length > 0
});
}

resetAll(){
	this.setState({
		currentCategoryID: 0,
		currentPage: 1,
		isLoading: true,
		prodLoaded: false,
		hasResults: true,
		canSearch: true,
		ProductList: [],
		SearchTerms: [],
		breadcrumb: [],
		categoryInfo: {
			selectedParentCategory: 0,
			selectedParentCategoryName: '',
			selectedCategoryName: '',
			selectedCategoryID: 0
		}
	}, () => {
		this.setURL();
	ProductBrowseActions.resetAll();
	let sendData = {
		categoryID: 0,
		currency: this.cart.primaryCurrency,
		page: 1,
		searchTerm: [],
		resultCount: this.state.resultCount
	};
	ProductBrowseActions.getNewProducts(sendData);
})
}

//Add To Cart. This must pull in the Cart Data from Local Storage and send the cartCode, offerCode and qty to the AddItemToCart Api Request. qty is Defaulted to 1
	AddToCart(offerCode, e) {
		let cart = CartActions.getCart();
		if(cart && cart.code){
			var addButton = $(e.target).closest('.add-to-cart-btn');
			var gridItem = addButton.closest('.product-grid-item');
			var gridItemImg = gridItem.find('.product-grid-image img');
			var gridItemImgPosition = gridItemImg.offset();
			if(gridItemImgPosition != undefined) {
				var dupeImg = gridItemImg.clone();
				$('#site-wrapper').append(dupeImg);

				var addButtonPosition = addButton.offset();
				dupeImg.css({
					border:'solid 1px #e08',
					position: 'absolute',
					top: gridItemImgPosition.top,
					left: gridItemImgPosition.left,
					height: 'auto',
					width: gridItemImg.width(),
					opacity: '1',
					zIndex:999
				}).appendTo('#site-wrapper');

				var miniCart = $('.navbar .miniCart-container');
				var miniCartPosition = miniCart.offset();

				dupeImg.animate({
					borderWidth: 6,
					top: gridItemImgPosition.top - 10,
					left: gridItemImgPosition.left - 10,
					width: gridItemImg.width() + 20
				}, 100, 'swing', function() {
					dupeImg.delay(200).animate({
						top: miniCartPosition.top,
						left: miniCartPosition.left,
						width: miniCart.width(),
						opacity: '0'
                    }, 500, 'swing', function () {
						$(this).remove();
					});
				});
			}
			CartActions.addItemToCart(cart.code, offerCode, 1);
		}
	}

deleteSearchTerm(term) {
	var index = this.state.SearchTerms.indexOf(term);
	let searchList = this.state.SearchTerms
	if (index > -1) {
		searchList.splice(index, 1);
	}
	this.setState({
		currentPage: 1,
		isLoading: true,
		prodLoaded: false,
		hasResults: true,
		canSearch: true,
		ProductList: [],
		SearchTerms: searchList
	}, () => {
		let sendData = {
			categoryID: this.state.currentCategoryID,
			currency: this.cart.primaryCurrency,
			page: 1,
			searchTerm: this.state.SearchTerms,
			resultCount: this.state.resultCount,
		};
	ProductBrowseActions.getNewProducts(sendData);
	this.setURL();
})

}

SearchCategories(data) { //added this from CategoryAreas.js
    this.props.SearchCategories(data);
    }
	
    getCurrentCategoryDescription(categoryCode, defaultValue) {
        let result = defaultValue;
        for (var i in this.state.CategoryList) {
            if (this.state.CategoryList[i].code === categoryCode)
                result = this.state.CategoryList[i].description;
        }
        return result;
    }

    getCurrentCategoryLongDescription(categoryCode, defaultValue) {
        let result = defaultValue;
        for (var i in this.state.CategoryList) {
            if (this.state.CategoryList[i].code === categoryCode)
                result = this.state.CategoryList[i].longDescription;
        }
        return result;
	}

	fileExists(file_url) {
		try {
			var http = new XMLHttpRequest();
			http.open('HEAD', file_url, false);
			http.send();
			return http.status !== 404;
		} catch (e) {
			return false;
		}
	}

    setBannerImage(categoryCode) {

        var banner_url = cdnimageurl.replace(/(^\w+:|^)\/\//, '//') + "/category-banners/" + window.jenkon.culture + "/" + categoryCode + ".jpg";
        //console.log('setBannerImage banner_url: ' + banner_url);

        var default_banner_url = cdnimageurl.replace(/(^\w+:|^)\/\//, '//') + "/category-banners/" + window.jenkon.culture + "/" + this.state.currentCategoryID + ".jpg";
        //console.log('default_banner_url: ' + default_banner_url);

        var no_banner_no_culture_url = cdnimageurl.replace(/(^\w+:|^)\/\//, '//') + "/category-banners/" + "en-US" + "/" + "0" + ".jpg";

        //NOTE: the below causes a CORS error (from localhost at least) when image is missing, even though server is open to "*"
        //able to test using "Moesif Origins & CORS Changer" plugin for Chrome
        //BUT need to test on an actual server...
        
        //test that category image exists for this theme...
        var image_exists = this.fileExists(banner_url);
        //console.log('test_url: ' + banner_url);
        //console.log('image_exists: ' + image_exists);

        //if not, try the deafult theme directory...
        if (image_exists === false) {
			if (banner_url != default_banner_url) {
	            image_exists = this.fileExists(default_banner_url);
			} 
            //console.log('test_url: ' + default_banner_url);
            //console.log('image_exists: ' + image_exists);
        }
        
        //set category-banner display to none if both are missing
        if (image_exists === false) {
			banner_url = no_banner_no_culture_url;
        }

        return banner_url;
    }

	getBannerImageUrl(categoryCode) {
		if (categoryCode)
        	return cdnimageurl.replace(/(^\w+:|^)\/\//, '//') + "/category-banners/" + window.jenkon.culture + "/" + categoryCode + ".jpg";
		else 
			return cdnimageurl.replace(/(^\w+:|^)\/\//, '//') + "/category-banners/" + "en-US" + "/" + "0" + ".jpg";
	}

	addDefaultSrc(ev){
		ev.target.src = this.getBannerImageUrl(null);
	}


    render() {
		const categoryImageUrl = this.getBannerImageUrl(this.state.currentCategoryID);

		return(
            <div className="product-browse-section clearfix">
                <div className="category-banner" style={{ display: this.state.currentBannerImageUrl === 'empty' ? 'none' : 'block' }}>
					<img className="category-banner-img" src={categoryImageUrl} alt={this.state.currentCategoryID} onError={this.addDefaultSrc} />

                    <div className="banner-text-box">
                        <div className="category">{this.getCurrentCategoryDescription(this.state.currentCategoryID, this.state.resources["PWS.Products.DefaultCategoryBannerTitle"] )}</div>
                        <div className="description">{this.getCurrentCategoryLongDescription(this.state.currentCategoryID, this.state.resources["PWS.Products.DefaultCategoryBannerDescription"] )}</div>
                    </div>
                </div>

				<BreadCrumbs ActiveCategories={this.categoryInfo} breadcrumbsList={this.state.breadcrumb} resources={this.state.resources} resetAll={this.resetAll.bind(this)} SearchCategories={this.getProductsForCategory.bind(this)} />

				<ProductGrid
					ProductList={this.state.ProductList}
					CategoryList={this.state.CategoryList}
					currentCategoryCode={this.state.currentCategoryID}
					resources={this.state.resources}
					AddToCart={this.AddToCart.bind(this)}
					SearchTerms={this.state.SearchTerms}
					deleteSearchTerm={this.deleteSearchTerm.bind(this)}
					hasResults={this.state.hasResults} loaded={this.state.prodLoaded}
					SearchCategories={this.getProductsForCategory.bind(this)}
					ResetCategories={this.resetAll.bind(this)}
				/>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./../../Deploy/PWS/ViewModels/Components/ProductBrowse/ProductBrowse.js